"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
var react_1 = require("react");
/**
 * @description Deve ser passado a referencia do elemento renderizado, que está sendo controlado. Será disparado quando o usuario
 * clicar fora do elemento de referencia.
 * @param ref É a referencia do elemento, conseguido por meio do useRef do react
 * @param handler É uma função de callback.
 */
var useOnClickOutside = function (ref, handler) {
    (0, react_1.useEffect)(function () {
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
        };
    }, [ref, handler]);
};
exports.useOnClickOutside = useOnClickOutside;
